import styled from 'styled-components';
import { CheckCircle } from '@styled-icons/bootstrap/CheckCircle';

export const TrackingContainer = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.colors.gray2};
  box-shadow: ${({ theme }) => theme.commoms.boxShadow};
  padding: 0.5rem;
  display: inline-flex;
  color: ${({ theme }) => theme.colors.grayDark};
  min-width: 22rem;
  margin-left: 0.5rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.laptop}) {
    min-width: 35rem;
    padding: 1rem;
    transform: translateX(-50%);
    left: 50%;
    margin-left: unset;
  }

  & > div.status {
    font-size: 0.875rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 1rem;
    min-width: 7rem;
    justify-content: space-between;
    padding-bottom: 0.65rem;

    &.delivered {
      justify-content: center;
      padding-bottom: 1rem;
    }

    & > h4 {
      margin-bottom: 0.3rem;
    }
  }

  & > div.tracking-error {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    font-size: 0.75rem;

    & > span {
      font-weight: bold;
    }

    & > button {
      color: ${({ theme }) => theme.colors.grayDark};
      max-width: 10rem;
      margin: 1rem auto 0 auto;
    }
  }
`;

export const TrackingTimeline = styled.div`
  display: flex;
  width: 80%;
  padding: 0.3rem 0;
  justify-content: center;

  & > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 8.5rem;
    font-size: 0.75rem;

    & > span {
      height: 1.125rem;
      font-weight: 600;
    }

    & > .dot {
      height: 0.5rem;
      width: 0.5rem;
      margin: 0.25rem 0;
      border-radius: 5px;
      background-color: ${({ theme }) => theme.colors.blue};
      position: relative;

      &.disabled {
        background-color: ${({ theme }) => theme.colors.gray3};
      }
    }

    // LINHA
    &:not(:first-child) > .dot {
      &::before {
        content: '';
        position: absolute;
        width: 8rem;
        height: 2px;
        top: 0.185rem;
        right: 0.5rem;
        background: ${({ theme }) => theme.colors.gray3};
      }

      &.paint-row::before {
        background: ${({ theme }) => theme.colors.blue};
      }
    }
  }
`;

export const DeliveredIcon = styled(CheckCircle)`
  width: 1rem;
  color: ${({ theme }) => theme.colors.green};
`;
